/** @format */

import React, { useState, useContext, useEffect } from "react";
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  makeStyles,
  CssBaseline,
  Box,
  Card,
  CardContent,
  Divider,
} from "@material-ui/core";
import Loading from "../modales/Loading";
import Error from "../Error";
import { AuthContext } from "../../context/Globales/AuthContext";
import { types } from "../../context/types";

import UserContext from "../../context/Globales/UserContext";

const useStyles = makeStyles((theme) => ({
  bg: {
    //  backgroundImage: `url(${process.env.PUBLIC_URL +'/static/imagen/hoja6.jpg'})`,
    height: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  form: {
    width: "90%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  paper: {
    margin: theme.spacing(10, 1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paperInside: {
    margin: theme.spacing(5, 1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  img: {
    width: '10rem',
    height: '3rem',
    alignItems: "center",
    justifyContent: "center",
  }

}));

const Login = () => {
  const isMobile = window.innerWidth < 768;
  const TipoTwo = JSON.parse(localStorage.getItem("autenticadoTwo"));
  const [OpenLoading, setOpenLoading] = useState(false);
  const [error, setError] = useState(false);
  const [MensajeLogin, setMensajes] = React.useState();


  const [login, setLogin] = useState({
    user: "",
    pass: "",
  });

  const { user, pass } = login;

  const classes = useStyles();

  const { getLogin } = useContext(UserContext);
  const { dispatch } = useContext(AuthContext);


  const handleChange = (e) => {
    setLogin({
      ...login,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    setOpenLoading(true);

    e.preventDefault();

    if (user === "" && pass === "") {
      setError(true);
      setMensajes("Todos los campos son obligatorios");
      setOpenLoading(false);
      return;
    } else if (user === "" && pass.length >= 1) {
      setError(true);
      setMensajes("El campo usuario es obligatorio");
      setOpenLoading(false);
      return;
    } else if (user.length >= 1 && pass === "") {
      setError(true);
      setMensajes("El campo contraseña es obligatorio");
      setOpenLoading(false);
      return;
    } else if (user.length >= 1 && pass.length >= 1) {
      
      getLogin(user, pass).then(() => {

        setOpenLoading(false);
        setError(false);

        e.target.reset();  

        dispatch({
          type: types.AuthLogin,
          payload: { name: user },
        });
      });
      
    } else {
      setOpenLoading(false);
      return;
    }
  };

  const refres = () => {
    localStorage.clear();
    window.location.reload();
  };

  if (TipoTwo === "retorna") {
    setTimeout(() => {
      localStorage.clear();
      window.location.reload();
    }, 6000);
  }

  useEffect(() => {
  }, [isMobile])

  return (
    <>
      {TipoTwo === "retorna" ? (
        <div
          style={{
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            marginLeft: "auto",
            marginRight: "auto",
            width: "70%",
          }}
          hidden={TipoTwo === "retorna" ? false : true}
        >
          <Card>
            <CardContent>
              <img
                src={process.env.PUBLIC_URL + "/static/imagen/200.gif"}
                alt="Loading carga"
                tile="loading carga espera!"
              ></img>
              <br />
              <h1>Espere un momento estamos procesando tu solicitud...</h1>
              <Divider />
              <p></p>
              <p>
                Si no redirecciona en 5 seg. presione el botón <b>Refrescar</b>{" "}
              </p>
              <Button variant="contained" color="primary" onClick={refres}>
                Refrescar
              </Button>
            </CardContent>
          </Card>
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            alignContent: "center",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          hidden={TipoTwo ? false : true}
        >
          <Card>
            <CardContent>
              <img
                src={process.env.PUBLIC_URL + "/static/imagen/200.gif"}
                alt="Loading carga"
                tile="loading carga espera!"
              ></img>
              <br />
              <h1>Espere un momento estamos procesando tu solicitud...</h1>
              <Divider />
              <p>
                Si no redirecciona en 5 seg. presione el botón <b>Refrescar</b>{" "}
              </p>
              <Button variant="contained" color="primary" onClick={refres}>
                Refrescar
              </Button>
            </CardContent>
          </Card>
        </div>
      )}
      <Paper
        className={classes.bg}
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "/static/imagen/hoja6.jpg"
          })`,
        }}
        hidden={TipoTwo ? true : false}
      >
        <CssBaseline />

        <br />
        {OpenLoading ? <Loading /> : null}
        <br />

        <Box display="flex" justifyContent="center" className={classes.paper}>
          <Grid
            container
            item
            xs={10}
            sm={7}
            md={5}
            xl={3}
            lg={3}
            component={Paper}
            elevation={3}
          >
            <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
              <Typography
                component="h1"
                variant="h5"
                style={{ textAlign: "center", paddingTop: "5px" }}
                className={classes.paperInside}
              >
                {" "}
                {/*el component es para queltome como un h1 */}
                <img
                  src={process.env.PUBLIC_URL + "/static/imagen/logoPortal.png"}
                  
                  title="Logo portal cheque"
                  alt="Logo portal cheque"
                  className={classes.img}

                />
                Acceso Clientes
              </Typography>
            </Grid>
            <Grid container justify="center" alignItems="center">
              <form
                className={classes.form}
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                {error ? <Error mensaje={MensajeLogin} /> : null}

                <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                  <TextField
                    type="text"
                    label="Usuario"
                    id="user"
                    margin="normal"
                    fullWidth
                    name="user"
                    value={user}
                    InputProps={{ pattern: "[0-9]" }}
                    onChange={handleChange}
                    variant="outlined"
                    autoFocus
                    autoComplete="off"
                  />

                  <TextField
                    type="password"
                    id="password"
                    label="Constraseña"
                    margin="normal"
                    fullWidth
                    name="pass"
                    value={pass}
                    onChange={handleChange}
                    variant="outlined"
                    autoComplete="off"
                  />
                </Grid>

                <Box my={2}>
                  <Button
                    color="secondary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Iniciar Sesión
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
export default Login;
